module.exports = __webpack_public_path__ + "static/media/guisado con curry.09d70e92.jpg";